<template>
  <div class="row">
    <div class="col-12">
      <table class="table table-bordered" style="border-collapse: collapse">
        <thead>
          <tr>
            <th scope="col" class="text-center" style="padding: 0">
              <img
                :src="require('../assets/svg/rentini-package.svg')"
                style="width: 150px"
              />
            </th>
            <th
              class="text-center package-title text-premium bg-premium"
              scope="col"
            >
              PREMIUM
            </th>
            <!-- <th
              class="text-center package-title text-starter bg-starter"
              scope="col"
            >
              STARTER
            </th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="text-center" style="vertical-align: middle" scope="row">
              การให้บริการด้านการตลาด
            </th>
            <td class="bg-premium">
              <ul class="list-unstyled">
                <li>
                  <i class="fas fa-check text-premium"></i>
                  ตำแหน่งโดดเด่นอยู่บนสุดของเว็บไซต์
                </li>
                <li>
                  <i class="fas fa-check text-premium"></i>
                  โปรโมทด้วยช่องทางการตลาดออนไลน์
                </li>
                <li>(Facebook, Google, Marketing Campaign และ อื่นๆ)</li>
              </ul>
            </td>
            <!-- <td class="bg-starter">
              <ul class="list-unstyled">
                <li>
                  <i class="fas fa-check text-starter"></i>
                  การแสดงผลแบบปกติทั่วไป
                </li>
              </ul>
            </td> -->
          </tr>
          <tr>
            <th class="text-center" style="vertical-align: middle" scope="row">
              การให้บริการด้านการขาย
            </th>
            <td class="bg-premium">
              <ul class="list-unstyled">
                <li>
                  <i class="fas fa-check text-premium"></i>
                  มีทีมงาน Rentini ช่วยปิดการขายให้กับหอพัก (ทีมเซลส์)
                </li>
                <li>
                  <i class="fas fa-check text-premium"></i>
                  มีทีมงานคัดกรองผู้สนใจอย่างมีประสิทธิภาพ
                </li>
                <li>
                  <i class="fas fa-check text-premium"></i>
                  มีทีมงานช่วยตอบคำถามเบื้องต้น และ นัดหมายการชมห้อง
                </li>
                <li>
                  <i class="fas fa-check text-premium"></i>
                  มีทีมงานด้านการตลาดคิดค้นโปรโมชั่น ผลักดันการขาย
                </li>
              </ul>
            </td>
            <!-- <td class="bg-starter">
              <ul class="list-unstyled">
                <li>
                  <i class="fas fa-check text-starter"></i>
                  หอพักปิดการขายด้วยตัวเอง <br />(ระบบฯส่งรายชื่อผู้ที่สนใจให้)
                </li>
              </ul>
            </td> -->
          </tr>
          <tr>
            <th class="text-center" style="vertical-align: middle" scope="row">
              การให้บริการเปิดใช้งานระบบ
            </th>
            <td
              class="bg-premium text-center"
              style="vertical-align: middle; font-size: large"
            >
              <b>ฟรี ไม่มีค่าใช้จ่าย</b>
            </td>
            <!-- <td
              class="bg-starter text-center"
              style="vertical-align: middle; font-size: large"
            >
              <b>ฟรี ไม่มีค่าใช้จ่าย</b>
            </td> -->
          </tr>
          <tr>
            <th class="text-center" style="vertical-align: middle" scope="row">
              เงื่อนไขค่าบริการ
            </th>
            <td
              class="bg-premium text-center"
              style="vertical-align: middle; font-size: large"
            >
              <b
                >มีค่านายหน้า
                <a href="#" @click="modalShow = !modalShow"
                  >ดูรายละเอียดเพิ่มเติม</a
                ></b
              >
            </td>
            <!-- <td
              class="bg-starter text-center"
              style="vertical-align: middle; font-size: large"
            >
              <b>ไม่มีค่านายหน้า</b>
            </td> -->
          </tr>
          <tr>
            <th scope="row"></th>
            <td class="bg-premium text-center">
              <button
                @click="choosePackage('premium')"
                class="btn btn-lg btn-package btn-premium"
              >
                เริ่มใช้งานแบบ Premium
              </button>
            </td>
            <!-- <td class="bg-starter text-center">
              <button
                @click="choosePackage('starter')"
                class="btn btn-lg btn-package btn-starter"
              >
                เริ่มใช้งานแบบ Starter
              </button>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-xs-12">
      <p class="ml-3">
        <b>
          <i class="fas fa-phone"></i>
          สอบถามรายละเอียดเพิ่มเติม ติดต่อ 061 985 5812 คุณบิ๋ม
        </b>
      </p>
    </div>
    <b-modal
      size="lg"
      v-model="modalShow"
      title="เงื่อนไขค่าบริการแพ็คเกจ Premium"
      ok-only
      ok-title="ปิด"
    >
      <p class="my-4">
        เมื่อทีมงาน RENTINI ปิดการขายห้องพักได้
        ทางหอพักจะชำระค่าตอบแทนในอัตราเหมาเป็นเงินดังนี้
      </p>
      <p class="my-4">
        - หากผู้เข้าพักที่ RENTINI แนะนำมาและช่วยปิดการขาย
        เมื่อผู้เช่าเข้าทำสัญญาเช่าห้อง อายุสัญญา เป็นรายปี
        ทางหอพักจะต้องชำระค่าบริการเป็นอัตราเท่ากับค่าเช่าและค่าบริการห้องในหอพักตามสัญญา
        ดังกล่าวจำนวน 1 เดือน
      </p>
      <p class="my-4">
        - หากผู้เข้าพักที่ RENTINI แนะนำมาและช่วยปิดการขาย
        เมื่อผู้เช่าเข้าทำสัญญาเช่าห้อง อายุสัญญา น้อยกว่า 1 ปี
        ทางหอพักจะต้องชำระค่าบริการเป็นอัตราเท่ากับร้อยละ 10
        ของมูลค่าของสัญญาดังกล่าว
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["onChoosePackage"],
  data() {
    return {
      modalShow: false,
    };
  },
  methods: {
    choosePackage(packageName) {
      this.onChoosePackage(packageName);
    },
  },
};
</script>

<style lang="scss" scoped>
$premiumBackground: rgba(244, 247, 253, 1);
$proBackground: rgba(239, 253, 253, 1);
$starterBackground: rgba(230, 254, 251, 1);
$premiumColor: rgba(0, 77, 156, 1);
$proColor: rgba(0, 202, 199, 1);
$starterColor: rgba(0, 189, 186, 1);
$textPrice: red;
.bg-premium {
  background-color: $premiumBackground;
}
.bg-pro {
  background-color: $proBackground;
}
.bg-starter {
  background-color: $starterBackground;
}
.text-premium {
  color: $premiumColor;
}
.text-pro {
  color: $proColor;
}
.text-starter {
  color: $starterColor;
}
.text-price {
  color: $textPrice;
}
.package-title {
  vertical-align: middle;
  font-size: x-large;
}
.hide-border-left-top {
  border-left: solid 1px #fff !important;
  border-top: solid 1px #fff !important;
}
.hide-border-left-bottom {
  border-left: solid 1px #fff !important;
  border-bottom: solid 1px #fff !important;
}
.btn-package {
  border-radius: 25px;
  padding-left: 40px;
  padding-right: 40px;
}
.btn-premium {
  background-color: $premiumColor;
  color: white;
}
.btn-pro {
  background-color: $proColor;
  color: white;
}
.btn-starter {
  background-color: $starterColor;
  color: white;
}
.coin {
  width: 30px;
}
</style>